<div [appIsLoading]="loadingService.isLoading(this, 'league')">
    <div *ngIf="league && league.textForAboveLeague" [innerHtml]="league.textForAboveLeague | sanitizeHtml"></div>
    <cs-shared-my-rank *ngIf="league" [salesAchievementLevel]="league.salesAchievementLevel"
        [winningPosition]="league.winningPositions" [attributes]="league.selectedColumns" [leagueData]="league.items"
        [isHubComponent]="true" [promotionName]="promotionName" [redirectionLink]="payload.redirectionLink">
    </cs-shared-my-rank>
    <div *ngIf="league && league.textForBelowLeague" [innerHtml]="league.textForBelowLeague | sanitizeHtml"></div>
</div>